<template>
  <el-drawer
    :visible.sync="drawer"
    :direction="direction"
    :before-close="handleClose"
    :append-to-body="true"
    custom-class="drawer"
    class="drawerpar"
    id="drawerpar"
    @open="init"
  >
    <template slot="title">
      <div class="bt"><img src="@/assets/yy.png" />华跃客服</div>
    </template>
    <div class="drawer__body" ref="scrollDiv">
      <div class="wh jxw">
        <img src="@/assets/yy.png" />
        <span>您好，华跃智能客服助理为您服务！</span>
      </div>
      <div class="wh">
        HI～，更懂制造业的HR,华跃HR，悦悦为您排忧解惑，请问有什么可以为您效劳呢？
      </div>
      <div class="wh">
        猜你想问
        <div
          v-for="(item, index) in qslist"
          :key="index"
          class="link"
          @click="go(item)"
        >
          <span>
            <i>{{ index + 1 }}</i
            >{{ item.title }}
          </span>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div
        :class="{ wh: true, ast: item.isast }"
        v-for="(item, index) in astlist"
        :key="index"
        v-html="item.html"
      />
    </div>
    <div class="drawer__footer">
      <div class="gdbtn">
        <div
          v-for="(item, index) in gdbtn"
          :key="index"
          v-html="item.text"
          @click="add(item.html)"
        />
      </div>
      <el-autocomplete
        placeholder="请输入内容"
        v-model="state"
        class="input-with-select"
        :trigger-on-focus="false"
        :fetch-suggestions="querySearch"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="send"
        ></el-button>
      </el-autocomplete>
    </div>
  </el-drawer>
</template>

<script>
import { GetTotal, search } from '@/api/content'
export default {
  name: 'ast',
  data() {
    return {
      drawer: false,
      state: '',
      direction: 'rtl',
      astlist: [],
      qslist: [{ title: 111111 }],
      qslist2: [],
      gdbtn: [
        {
          text: '联系售后',
          html:
            '问题解答：刘小姐 0757-22115226 <br>服务监督：程圆龙 15976666086'
        },
        {
          text: '移动售后',
          html:
            '微信搜索“华跃之家”关注==》点击华跃资讯==》售后平台==》登陆<p>我的作用：问题工单可以通过手机端提交，可以接单信息提醒，工程反馈回复提醒，工单完结满意度评分历史发帖问题查询。实现在线化售后服务互联中心，让华跃服务永相随。</p>'
        },
        {
          text: '售后平台',
          html:
            '<a href="http://120.76.77.155:8055/" target="_blank">售后平台入口</a>'
        }
      ]
    }
  },
  methods: {
    querySearch(queryString, cb) {
      var restaurants = this.qslist2
      var results = queryString
        ? restaurants.filter(e => {
            return e.value.indexOf(queryString) > -1
          })
        : []
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    go(item) {
      let url = 'http://120.76.77.155:8055/tech/viewtech2?autoid=' + item.autoid
      window.open(url)
    },
    send() {
      this.astlist.push({ html: this.state, isast: true })
      search({ keywork: this.state }).then(rrs => {
        if (rrs.error == 0) {
          // this.qslist = rrs.list
          let html =
            rrs.list.length > 0
              ? '<a href="http://120.76.77.155:8055/tech/viewtech2?autoid=' +
                rrs.list[0].autoid +
                '" target="_blank">' +
                rrs.list[0].title +
                '</a>'
              : '没有相关内容，请到售后平台咨询：<a href="http://120.76.77.155:8055/" target="_blank">售后平台入口</a>'
          this.add(html)
        }
      })
      this.state = ''
      this.scrollDiv()
    },
    add(html) {
      this.astlist.push({ html: html })
      this.scrollDiv()
    },
    scrollDiv() {
      this.$nextTick(() => {
        let scrollElem = this.$refs.scrollDiv
        scrollElem.scrollTo({
          top: scrollElem.scrollHeight,
          behavior: 'smooth'
        })
      })
    },
    init() {
      this.astlist = []
      GetTotal().then(rrs => {
        if (rrs.error == 0) {
          rrs.list2.forEach(e => {
            e.value = e.title
          })
          this.qslist = rrs.list
          this.qslist2 = rrs.list2
        }
      })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    }
  }
}
</script>

<style lang="less" scoped>
#drawerpar {
  font-family: OPPOSans-M;
  /deep/.el-drawer {
    background: #eee;
    .el-drawer__header {
      background: #fff;
      padding-bottom: 20px;
      margin-bottom: 0;
      .bt {
        text-align: center;
        font-weight: bold;
        img {
          vertical-align: middle;
          width: 1.5em;
          margin-right: 5px;
        }
      }
    }
    .el-drawer__body {
      .drawer__body {
        padding: 20px;
        height: calc(100% - 80px);
        overflow-y: auto;
        overflow-x: hidden;
        .wh {
          background: #fff;
          border-radius: 5px;
          position: relative;
          line-height: 20px;
          padding: 10px;
          margin-bottom: 20px;
          img {
            width: 60px;
            position: absolute;
            left: 5px;
            top: -20px;
          }
          p {
            text-indent: 2em;
          }
          .link {
            display: flex;
            justify-content: space-between;
            cursor: pointer;
            i {
              margin-right: 10px;
                  font-style: normal;
            }
          }
          .link:hover {
            color: rgba(22, 117, 246);
          }
        }
        .jxw {
          padding-left: 70px;
        }
        .ast {
          background: rgba(22, 117, 246, 0.32);
          text-align: right;
        }
      }

      .drawer__footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 80px;
        padding: 0 20px;
        .gdbtn {
          display: flex;
          div {
            height: 20px;
            border-radius: 10px;
            border: 1px solid #ccc;
            padding: 0 10px;
            margin: 5px;
            cursor: pointer;
          }
          div:hover {
            background: rgba(22, 117, 246, 0.32);
          }
        }
        .el-autocomplete {
          width: 100%;
        }
      }
    }
  }
}
</style>
